Vue.component('streamer-obs-settings', {
  template: templates.streamerObsSettings,

  data() {
    return {
      panelExpanded: true,
      displayMode: 'broadcast', // 'broadcast' or 'extension'
      settingChangeMessage: '',
      messageType: '' // 'success', 'error'
    };
  },

  created() {
    this.loadDisplayMode();
  },

  methods: {
    togglePanel() {
      this.panelExpanded = !this.panelExpanded;
      if (this.panelExpanded) {
        this.loadDisplayMode();
      }
    },

    /**
     * Load display mode preference from backend or localStorage fallback
     */
    loadDisplayMode() {
      const c = this;
      const channelId = utils.cookies.get('channelId');

      if (!channelId) {
        // Fallback to localStorage if no channel ID
        const saved = localStorage.getItem('obsDisplayMode');
        c.displayMode = (saved && streamerDisplayModeService.isValidMode(saved)) ? saved : 'broadcast';
        console.log('[Streamer OBS Settings] No channel ID, using localStorage fallback:', c.displayMode);
        return;
      }

      // Load from backend API using service
      streamerDisplayModeService.get(channelId)
        .then(response => {
          if (response.data.success && response.data.data) {
            c.displayMode = response.data.data.displayMode || 'broadcast';
            console.log('[Streamer OBS Settings] Loaded display mode from backend:', c.displayMode);
          } else {
            throw new Error(response.data.message || 'Unknown error');
          }
        })
        .catch(error => {
          console.error('[Streamer OBS Settings] Error loading from backend:', error);
          // Fallback to localStorage
          const saved = localStorage.getItem('obsDisplayMode');
          c.displayMode = (saved && streamerDisplayModeService.isValidMode(saved)) ? saved : 'broadcast';
          console.log('[Streamer OBS Settings] Falling back to localStorage:', c.displayMode);
        });
    },

    /**
     * Change display mode
     */
    changeDisplayMode(mode) {
      const c = this;

      if (!['broadcast', 'extension'].includes(mode)) {
        console.error('[Streamer OBS Settings] Invalid display mode:', mode);
        return;
      }

      c.displayMode = mode;
      c.saveDisplayMode(mode);
    },

    /**
     * Save display mode preference to backend and localStorage
     */
    saveDisplayMode(mode) {
      const c = this;
      const channelId = utils.cookies.get('channelId');

      // Validate mode
      if (!streamerDisplayModeService.isValidMode(mode)) {
        console.error('[Streamer OBS Settings] Invalid display mode:', mode);
        return;
      }

      // Always save to localStorage first (for immediate UI feedback)
      localStorage.setItem('obsDisplayMode', mode);
      console.log('[Streamer OBS Settings] Display mode saved to localStorage:', mode);

      // Show success message
      c.settingChangeMessage = mode === 'broadcast'
        ? '✓ Display mode set to OBS Broadcast - packs will show on your stream'
        : '✓ Display mode set to Extension Only - packs hidden from OBS';
      c.messageType = 'success';

      // Clear message after 4 seconds
      setTimeout(() => {
        c.settingChangeMessage = '';
      }, 4000);

      // Save to backend API if channel ID is available
      if (channelId) {
        streamerDisplayModeService.save({
          displayMode: mode,
          channelId: channelId
        })
          .then(response => {
            if (response.data.success) {
              console.log('[Streamer OBS Settings] Display mode saved to backend:', mode);
            } else {
              throw new Error(response.data.message || 'Unknown error');
            }
          })
          .catch(error => {
            console.error('[Streamer OBS Settings] Warning: Failed to save to backend:', error);
            console.log('[Streamer OBS Settings] Preference is saved locally (localStorage) but not persisted to database');
          });
      } else {
        console.warn('[Streamer OBS Settings] No channel ID available - preference only saved to localStorage');
      }
    }
  }
});
